import React from "react"

import { styled } from "@mui/material"

import { Link } from "react-router-dom"

const StyledLink = styled(Link)({
  display: "inline-block",
  color: "inherit",
  textDecoration: "none",
  "&:hover": {
    color: "inherit"
  }
})

const isExternal = (url) => /^https?:\/\//.test(url)

const HKVLink = ({ to, highlight, ...props }) => {
  const external = isExternal(to)

  if (external) {
    return (
      <StyledLink
        to={to}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      />
    )
  } else {
    return (
      <StyledLink
        to={to}
        href={to}
        {...props}
      />
    )
  }
}

export default React.memo(HKVLink)